
const EXHIBITION_IMAGE_CAROUSEL_IMAGE_CLASS = 'block-exhibition-image--carousel';
const EXHIBITION_IMAGE_SELECTOR = '.block-exhibition-image:not(.' + EXHIBITION_IMAGE_CAROUSEL_IMAGE_CLASS + ')';
const EXHIBITION_IMAGE_CAROUSEL_TARGET_SELECTOR = '[data-exhibition-image-carousel]';

export default class ExhibitionImageCarousel {
    constructor() {
        this.build();
    }

    getSettings() {
        return {
            loop: true,
            margin: 10,
            nav: true,
            items: 1,
            autoheight: true,
            nav: false
        }
    }

    build() {
        const carouselTarget = $(EXHIBITION_IMAGE_CAROUSEL_TARGET_SELECTOR);
        const srcImages = $(EXHIBITION_IMAGE_SELECTOR);
        srcImages.clone().addClass(EXHIBITION_IMAGE_CAROUSEL_IMAGE_CLASS).appendTo(carouselTarget);

        carouselTarget.owlCarousel(this.getSettings());
    }
}


// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/App/Exhibition/ExhibitionImageCarousel.js